import { mapGetters, mapActions, mapMutations } from 'vuex';
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';

export default {
    name: 'propertyNeighborhood',
    inject: ['$eventBus'],
    props: ['disableCollapse', 'isActive'],
    components: {
        mvtMapStatic,
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp', 'getLocalHighlightScore']),
        markers() {
            return [{ lat: this.dpp.geo.lat, lng: this.dpp.geo.lng, type: this.dpp.propertyType }];
        },
        cards() {
            const scores = this.getLocalHighlightScore;
            return scores
                ? [
                      {
                          title: 'Walk',
                          score: scores.walk,
                          icon: 'walking',
                          info: "Measures the location's friendliness to pedestrians based on its proximity to nearby places of interest. Based on a scale of 1-100.",
                      },
                      {
                          title: 'Family',
                          score: scores.kid,
                          icon: 'kid',
                          info: 'Measures the % of households with children in the area. Based on a scale of 58-100.',
                      },
                      {
                          title: 'Dining',
                          score: scores.food,
                          icon: 'poi-eat',
                          info: 'Measures the variety of restaurants within a short driving distance. Based on a scale of 1-100.',
                      },
                      {
                          title: 'Pet',
                          score: scores.pet,
                          icon: 'dog',
                          info: 'Measures the availability of nearby pet stores, veterinarians, and other pet-focused service providers. Based on a scale of 58-100.',
                      },
                  ]
                : [];
        },
    },
    methods: {
        popMapView(params) {
            this.$eventBus.$emit('property-pop-map', params);
        },
    },
};
